import CancelJobPage from "./CancelJobPage";

export default CancelJobPage;